export type MFARedirectDestination = 'profile' | 'settings' | 'users';

const mfaRedirectPaths: Record<MFARedirectDestination, string> = {
  profile: '/user-profile',
  settings: '/settings/organization',
  users: '/setup/users',
};

// Keep redirect destinations fixed and carry the realm across Keycloak round trips.
export function createMFARedirectUri(
  currentUrl: string,
  organization: string,
  destination: MFARedirectDestination = 'profile',
) {
  const url = new URL(currentUrl);
  url.pathname = mfaRedirectPaths[destination];
  url.search = '';
  url.hash = '';
  url.searchParams.set('organization', organization);
  if (destination === 'profile') url.searchParams.set('tab', 'security');
  return url.toString();
}

export function getMFAError(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  return 'Unable to update two-factor authentication. Please try again.';
}

export function needsMFAReauthentication(error: unknown): boolean {
  return (
    !!error &&
    typeof error === 'object' &&
    'code' in error &&
    ((error as { code?: number }).code === 16 ||
      ((error as { code?: number }).code === 9 &&
        getMFAError(error).startsWith('sign in again')))
  );
}
